import { useEffect, useState } from 'react';
import {
  ApiErrorText,
  // Button,
  ModalComponentWrapper,
} from '@/shared/components';
// import HistoryIcon from '@/shared/assets/history-icon.svg?react';
import { useWithdrawSbpForm, type WithdrawSbpModalState } from '../model';
import { useTranslation } from 'react-i18next';
import { NUMERIC_CONFIG } from '@/shared/config';
import { useModalStoreState } from '@/shared/lib';
import { useWithdrawSbpModals } from '../lib';
import { WithdrawSbpForm } from './WithdrawSbpForm';
import { WithdrawModalFooter } from '@/entities/operation';
import type { OperationModalProps } from '@/shared/types';

export const WithdrawSbpModal = ({
  onBack,
  title,
  // onHistoryClick,
}: OperationModalProps) => {
  const [isFormDirty, setIsFormDirty] = useState(false);
  const { t } = useTranslation();
  const { setMultipleState, setCloseConfirmationRequired } =
    useModalStoreState<WithdrawSbpModalState>();
  const { openConfirmationModal } = useWithdrawSbpModals();

  useEffect(() => {
    setCloseConfirmationRequired(isFormDirty);
  }, [isFormDirty, setCloseConfirmationRequired]);

  const {
    form,
    watchedValues,
    assetOptions,
    selectedCurrency,
    bankOptions,
    selectedBank,
    hasWithdrawFee,
    isFromDataLoading,
    isFormDataError,
    formDataError,
    feeAmount,
    totalAmount,
    error,
    handleMaxClick,
    isLoading,
    paymentTypeCode,
  } = useWithdrawSbpForm();

  const updateState = () => {
    setMultipleState({
      withdrawSbpFormData: watchedValues,
      fee: feeAmount,
      selectedCurrency,
      selectedBank,
      totalAmount,
      paymentTypeCode,
    });
  };

  // const onHistoryClickHandler = () => {
  //   updateState();
  //   onHistoryClick(
  //     selectedCurrency?.code ? { assetCode: selectedCurrency?.code } : undefined
  //   );
  // };

  const onSubmit = async () => {
    const isValid = await form.trigger();

    if (isValid && paymentTypeCode) {
      updateState();
      openConfirmationModal();
    }
  };

  return (
    <ModalComponentWrapper
      title={title}
      onBack={onBack}
      // actions={
      //   <Button
      //     variant="secondary"
      //     onClick={onHistoryClickHandler}
      //     className="flex items-center justify-center size-[4.2rem] bg-muted hover:bg-muted/80 bg-transparent-bg transition-colors text-foreground shadow-none self-start rounded-full border border-border mr-[0.8rem]"
      //     aria-label="history">
      //     <HistoryIcon className="size-[2.4rem] text-foreground" />
      //   </Button>
      // }
      footerClassName="sm:px-0 px-0 before:invisible"
      footer={
        <WithdrawModalFooter
          precision={NUMERIC_CONFIG.precision.default}
          amount={totalAmount}
          assetCode={watchedValues.currencyCode}
          withdrawFee={isLoading ? 0 : feeAmount}
          includeFee={hasWithdrawFee && Boolean(watchedValues.includeFee)}
          disabled={isFromDataLoading || isLoading}
          isLoading={isLoading}
          onSubmit={onSubmit}
          submitLabel={t('withdrawMethods.crypto.submitButton')}
        />
      }>
      <WithdrawSbpForm
        form={form}
        watchedValues={watchedValues}
        assetOptions={assetOptions}
        selectedAsset={selectedCurrency}
        bankOptions={bankOptions}
        selectedBank={selectedBank}
        hasWithdrawFee={hasWithdrawFee}
        isLoading={isFromDataLoading}
        isError={isFormDataError && !isLoading}
        error={formDataError}
        onMaxClick={handleMaxClick}
        onFormDirtyChange={setIsFormDirty}
      />
      {!isLoading && error && <ApiErrorText error={error} />}
    </ModalComponentWrapper>
  );
};
